import React from "react";
import BackImg from "../images/backBtn.svg";
import CheckImg from "../images/check.svg";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
function RoomFeature(props) {
  const navigate = useNavigate();
  const lengthTrue = props.lengthcheck;
  const close = () => {
    if(lengthTrue === true){
      navigate('/home');
    }else{
      props.hide();
    }
  };
  return (
    <div className="w-full">
      <div className="relative spot-my-room section-wrap">
        <div onClick={close} className="absolute cursor-pointer left-5 top-5 z-10 p-5 pt-0 pl-0 ">
          <div className="flex justify-center items-center rounded-[8px] p-2 bg-[#3d3d3d]">
          <img src={BackImg} alt="" />
          </div>
              </div>
             </div>
                    <div
                // style={{
                //   background: props.roomData.image?.length
                //     ? `url(${props.roomData.image[0]})`
                //     : "gray",
                // }}
                className="cover-img-div sm:h-[300px] h-[240px] bg-cover bg-no-repeat w-full relative rounded-md"
              >
                <Carousel
                  showArrows={false} // Disable arrows
                  showThumbs={false} // Disable thumbnails
                  infiniteLoop={true} // Enable infinite loop
                  autoPlay={true} // Enable autoplay
                  interval={3000} // Set autoplay interval
                  className="absolute inset-0 w-full h-full z-0" // Fill parent div
                  dynamicHeight={false} // Keep height consistent
                  statusFormatter={() => ""}
                >
                  {props.roomData.image?.length > 0 &&
                    props.roomData.image.map((image, index) => (
                      <div
                        className="cover-img-div sm:h-[300px] h-[240px] bg-cover bg-no-repeat w-full relative rounded-md"
                        key={index}
                      >
                        <img
                          className="object-cover w-full h-full"
                          src={image}
                          alt={`Hotel Image ${index + 1}`} // Use template literal correctly
                        />
                      </div>
                    ))}
                </Carousel>
              </div>
            {console.log(props.roomData)}
      <div className="p-4 pb-20 section-wrap">
        {props.roomData.typeName &&
          <div className="type-head">Category - {props.roomData.typeName}</div>
        }
        <div className="type-facilities my-3">Facilities</div>
        {props.roomData.fecilities.map((item, i) => (
          <div key={i} className="flex items-center gap-3 mb-2">
            <img className="w-4 h-4" src={CheckImg} alt="" />
            <div className="type-facility">{item}</div>
          </div>
        ))}

      {props.roomData.description && <div className="mt-6">
          <div className="type-details">Details</div>
          <p className="type-para mt-2">
            {props.roomData.description}
          </p>
        </div>}
      </div>
    </div>
  );
}

export default RoomFeature;
